import gql from 'graphql-tag';

export class DashboardQueries {
  static documentsByType = gql`
    query DocumentByStatsType($type: DocumentStatsType!, $showAll: Boolean) {
      documentStatsByType(type: $type, showAll: $showAll) {
        value
        count
      }
    }
  `;

  static documentHits = gql`
    query DocumentHits($signDateInterval: DateIntervalInput!, $showAll: Boolean) {
      documentHits(signDateInterval: $signDateInterval, showAll: $showAll) {
        value
        count
      }
    }
  `;

  static topPerformers = gql`
    query TopPerformers($dateInterval: DateIntervalInput!) {
      topPerformers(dateInterval: $dateInterval) {
        firstName
        lastName
        thumbUrl
        signedNrOfDocuments
        valueOfDocuments
        totalNrOfDocuments
      }
    }
  `;

  static documentDealTimes = gql`
    query DocumentDealTimes($signDateInterval: DateIntervalInput!, $showAll: Boolean) {
      documentDealTimes(signDateInterval: $signDateInterval, showAll: $showAll) {
        hours
        days
      }
    }
  `;

  static estimateClosingDeals = gql`
    query EstimateClosingDeals($avgCloseDays: Float, $showAll: Boolean) {
      estimateClosingDeals(avgCloseDays: $avgCloseDays, showAll: $showAll) {
        value
        count
      }
    }
  `;
}
